import { render, staticRenderFns } from "./RoleGroupsForm.vue?vue&type=template&id=2bfc15ae&scoped=true&"
import script from "./RoleGroupsForm.vue?vue&type=script&lang=js&"
export * from "./RoleGroupsForm.vue?vue&type=script&lang=js&"
import style0 from "./RoleGroupsForm.vue?vue&type=style&index=0&id=2bfc15ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfc15ae",
  null
  
)

export default component.exports